import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import JsonExcel from 'vue-json-excel'
import Vuelidate from 'vuelidate'

import '@/assets/css/main.scss'

import stringMaxLengthFilter from './filters/stringMaxLength.filter'

// Plugins
import '@/utils/filters/dateFilters.js'

Vue.use(Vuelidate)
Vue.filter('stringMaxLength', stringMaxLengthFilter)
Vue.component('downloadExcel', JsonExcel)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
